import type { ReactNode } from 'react'

import { Flex, Icon } from '@percent/lemonade'
import styles from './HistoryListItem.module.scss'

function TimelineIcon({ finished }: { finished: boolean }) {
  if (finished) {
    return (
      <Flex className={styles.timelineIcon}>
        <Icon name="approve" color="success400" size={5} />
      </Flex>
    )
  }

  return (
    <Flex className={styles.timelineIcon}>
      <span className={styles.timelineIconUnchecked} data-testid="achievementNotReceivedIcon" />
    </Flex>
  )
}

export type HistoryListItemProps = Readonly<{
  children: ReactNode
  markAsFinished?: boolean
}>

export function HistoryListItem({ children, markAsFinished = false }: HistoryListItemProps) {
  return (
    <Flex w="100%" direction="row" className={styles.wrapper} data-testid="history-item">
      <Flex direction="column" className={styles.timelineWrapper}>
        <TimelineIcon finished={markAsFinished} />
        <div className={styles.timelineLine} />
      </Flex>
      <div className={styles.content}>{children}</div>
    </Flex>
  )
}
